import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import config from 'devextreme/core/config';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { devExpressLicenseKey } from './devexpress-key';

if (environment.production) {
    enableProdMode();
}
config({ licenseKey: devExpressLicenseKey })

platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
